import type { Schrift } from '@dxl/shared';

/**
 * Schriften des Brandings – selbst ausgeliefert (keine Anfrage an Google). Jede Schrift ist ein eigener
 * Chunk und wird erst geladen, wenn ein Marktplatz sie verwendet. Montserrat steckt bereits im Hauptpaket.
 */
const LADER: Record<Schrift, () => Promise<unknown>> = {
  Montserrat: async () => undefined,
  'DM Sans': () => import('@fontsource-variable/dm-sans/wght.css'),
  Poppins: () => Promise.all([
    import('@fontsource/poppins/400.css'),
    import('@fontsource/poppins/500.css'),
    import('@fontsource/poppins/600.css'),
    import('@fontsource/poppins/700.css'),
  ]),
  'Nunito Sans': () => import('@fontsource-variable/nunito-sans/wght.css'),
  'Source Sans 3': () => import('@fontsource-variable/source-sans-3/wght.css'),
  Lato: () => Promise.all([import('@fontsource/lato/400.css'), import('@fontsource/lato/700.css')]),
  'Open Sans': () => import('@fontsource-variable/open-sans/wght.css'),
  Raleway: () => import('@fontsource-variable/raleway/wght.css'),
};

const geladen = new Map<Schrift, Promise<unknown>>();

export function schriftLaden(s: Schrift): Promise<unknown> {
  let p = geladen.get(s);
  if (!p) {
    p = LADER[s]().catch(() => geladen.delete(s));
    geladen.set(s, p);
  }
  return p;
}

/** Favicon des Marktplatzes (App-Icon) – ohne eigenes Icon das DXL-Zeichen */
export function faviconSetzen(icon: string | null): void {
  for (const link of document.querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="apple-touch-icon"]')) {
    if (!link.dataset.dxl) link.dataset.dxl = link.getAttribute('href') ?? '';
    const ziel = icon ?? link.dataset.dxl;
    if (link.getAttribute('href') !== ziel) link.setAttribute('href', ziel);
    if (link.rel === 'icon') link.type = icon ? '' : link.dataset.dxl.endsWith('.svg') ? 'image/svg+xml' : '';
  }
}
